import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { power5 } from '../helper/easing';
power5();
gsap.registerPlugin(SplitText);

const text = {
	init() {

        document.fonts.ready.then(function () {
       
            /* 
            !!!!!!!!!!!!!!!!!!
            !!!!!!!!!!!!!!!!!!
            Split text set up
            !!!!!!!!!!!!!!!!!!
            !!!!!!!!!!!!!!!!!!
            */            
			let splitLines1_1 = new SplitText('#k-content .js-split-lines', {
				type: 'lines',
				linesClass: 'js-line'
			});      
			let splitLines1_2 = new SplitText('#k-content .js-split-lines', {
				type: 'lines',
				linesClass: 'js-line-wrapper'
			});              
			let splitLines2_1 = new SplitText('#k-content .js-split-lines-mce p, #k-content .js-split-lines-mce li, #k-content .js-split-lines-mce h3, #k-content .js-split-lines-mce h4, #k-content .js-split-lines-mce h5', {
				type: 'lines',
				linesClass: 'js-line'
			});      
			let splitLines2_2 = new SplitText('#k-content .js-split-lines-mce p, #k-content .js-split-lines-mce li, #k-content .js-split-lines-mce h3, #k-content .js-split-lines-mce h4, #k-content .js-split-lines-mce h5', {
				type: 'lines',
				linesClass: 'js-line-wrapper'
			});                          
            let splitWords1 = new SplitText('#k-content .js-ani-font-bend', {
                type: 'lines',
                linesClass: 'js-line'
            });      
            let splitChars = new SplitText('#k-content .js-ani-font-bend span', {
                type: 'chars',
                charsClass: 'js-char'
            });                                    

            /* 
            !!!!!!!!!!!!!!!!!!
            !!!!!!!!!!!!!!!!!!
            Split text animations
            !!!!!!!!!!!!!!!!!!
            !!!!!!!!!!!!!!!!!!
            */            
            const splitAniTriggers = document.querySelectorAll('.js-split-lines-trigger');
            
            splitAniTriggers.forEach(splitAniTrigger => {             
                
                var pos = "0% 60%";
				if (splitAniTrigger.dataset.scrollposition) {
					pos = splitAniTrigger.dataset.scrollposition;
				}
                const tl = gsap.timeline({delay: 0});
                const copy = splitAniTrigger.querySelectorAll('.js-split-lines-hidden');
                const line = splitAniTrigger.querySelectorAll('.js-line');
                const tDuration = 2.3;
                const tStagger = 0.1;
            
                tl.set(copy, {opacity: 1}, 0)
                .fromTo(line, tDuration, {
                    y: '130%',
                },
                {
                    y: '0',
                    ease: 'power5.out',
                    stagger: tStagger,
                }, 0)
                ;            
            
                // Only use scrollTrigger if the section isn't already in the viewport
                if (splitAniTrigger != document.querySelector('#k-content').firstElementChild) {
                    ScrollTrigger.create({
                        // markers: true,
                        trigger: splitAniTrigger,
                        animation: tl,
                        once: true,
                        start: pos
                    });        
                }
            
            }); 

            /* 
            !!!!!!!!!!!!!!!!!!
            !!!!!!!!!!!!!!!!!!
            Variable font animations
            !!!!!!!!!!!!!!!!!!
            !!!!!!!!!!!!!!!!!!
            */            
            // function getRand(min,max){
            //     return Math.random() * (max - min) + min;
            // }
            
            let fontBends = document.querySelectorAll('#k-content .js-ani-font-bend');
            fontBends.forEach(item => {

                async function aniClass() {
                    item.classList.add('ani-font-bend-prep');
                }


                aniClass().then(() => {

                    if (item.classList.contains('opacity-0')){
                        gsap.to(item, {opacity: 1, duration: 1});
                    }
                    let aniTarget = item.querySelectorAll('span');
                    if (aniTarget.length > 0) {

                        let chars = item.querySelectorAll('span .js-char'),
                        randChar = gsap.utils.random(1,chars.length,1),
                        bigChar = item.querySelector(`span .js-char:nth-child(${randChar})`),
                        smallChars = item.querySelectorAll(`span .js-char:not(:nth-child(${randChar}))`),
                        charWidth = window.getComputedStyle(item).getPropertyValue('--wdth'),
                        maxWidth = chars.length * charWidth;
                        
                        
                        // console.log(bigChar.style('fontVariationSettings', "'wdth'");
                            
                            // console.log('word');
                            // let doPinch = () => {
                                
                                // var tl = gsap.timeline({onComplete:doPinch});
                                
                                var tl = gsap.timeline({repeat: -1});
        
                                let randDuration = gsap.utils.random(0.3, 0.6, 0.1),
                                    randDelay = gsap.utils.random(5, 8, 0.1),
                                    randWait = gsap.utils.random(0.5, 2, 0.1);
                                    
                                // console.log('duration ' + randDuration + ' delay ' + randDelay);
                                tl.to(bigChar, 
                                    {
                                        '--wdth': maxWidth, 
                                        duration: randDuration, 
                                        ease: 'back.out(3)',
                                    }, randDelay)
                                .to(smallChars, 
                                    {
                                        '--wdth': 0, 
                                        duration: randDuration, 
                                        ease: 'back.out(3)',
                                    }, randDelay) 
                                .to(bigChar, 
                                    {
                                        '--wdth': charWidth, 
                                        duration: randDuration, 
                                        ease: 'back.out(3)',
                                    }, randDelay + randWait + randDuration)
                                .to(smallChars, 
                                    {
                                        '--wdth': charWidth, 
                                        duration: randDuration, 
                                        ease: 'back.out(3)',
                                    }, randDelay + randWait + randDuration)
                                ;
        
                            // }
        
                            // doPinch();
    


                    }

                });
            });

        });        
	},
};

export default text;